import { PropertyAccessor, ValidationRules, FluentRules, ValidationMessageProvider, validationMessages, ValidationController } from 'aurelia-validation';

declare module 'aurelia-validation' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace ValidationRules {
    function ensureEx<TObject, TValue>(property: PropertyAccessor<TObject, TValue>): FluentRules<TObject, TValue>;
  }

  interface FluentRuleCustomizer<TObject, TValue> {
    ensure<TValue>(subject: string | ((model: TObject) => TValue)): FluentRules<TObject, TValue>;
  }

  interface ValidationController {
    isValid(): Promise<boolean>;
  }
}

ValidationRules.ensureEx = function <TObject, TValue>(property: PropertyAccessor<TObject, TValue>): FluentRules<TObject, TValue> {
  return ValidationRules.ensure(property);
};

ValidationMessageProvider.prototype.getDisplayName = function () { return ''; };
for (const key in validationMessages) {
  const message = validationMessages[key];
  if (message.endsWith('.')) {
    // eslint-disable-next-line no-template-curly-in-string
    validationMessages[key] = message.substring(0, message.length - 1).replace('${$displayName}', '').trim();
  }
}

ValidationController.prototype.isValid = async function (this: ValidationController) {
  return (await this.validate()).valid;
};
